import { useEffect, useState } from "react";
import LinearProgress,{linearProgressClasses}  from '@mui/material/LinearProgress';
import { styled } from "@mui/material/styles";

const CustomLinearProgress = styled(LinearProgress)(() => ({
    height: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: "transparent"
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: "#1e96fc",
    },
  }));

const Navbar = ({ refs }) => {
    const [scrollTop, setScrollTop] = useState(0);
   
    useEffect(() => {
        const onScroll = () => {
            const winScroll = document.documentElement.scrollTop;
            const height = document.documentElement.scrollHeight - document.documentElement.clientHeight - 10;
            const scrolled = (winScroll / height) * 100;
            setScrollTop(scrolled);
        }
        window.addEventListener("scroll", onScroll);
        return () => { window.removeEventListener("scroll", onScroll) }
    }, [])

    return (
        <>
            <div style={{
                position: "fixed",
                top: 0, zIndex: 1000, backgroundColor: "#4e5157", fontSize: "1.5rem", display: "flex", paddingTop: "1rem", color: "white", marginLeft: "auto",
                marginRight: "auto", justifyContent: "center",
                flexDirection: "column", width: "100%", alignContent: "start"
            }}>
                <div style={{ display: "flex", justifyContent: "center" }}>

                    <div style={{ display: "flex" }} className="dancing-script-title">
                        &lt;Abhilash&gt;
                    </div>
                    <div style={{ display: "flex", width: "55rem", justifyContent: "space-evenly" }}>
                        <span className="nav-elements" onClick={() => {
                            refs.refAbout.current.scrollIntoView({ behaviour: "smooth" });
                            window.scrollBy(0, 0);
                        }}>About</span>
                        <span className="nav-elements" onClick={() => {
                            refs.refProjects.current.scrollIntoView({ behaviour: "smooth" });
                            window.scrollBy(0, 0);
                        }}>Projects</span>
                        <span className="nav-elements" onClick={() => {
                            refs.refSkills.current.scrollIntoView({ behaviour: "smooth" });
                            window.scrollBy(0, 0);
                        }}>Skills</span>
                        <span className="nav-elements" onClick={() => {
                            refs.refExperience.current.scrollIntoView({ behaviour: "smooth" });
                            window.scrollBy(0, 0);
                        }}>Experience</span>
                        <span className="nav-elements" onClick={() => {
                            refs.refEducation.current.scrollIntoView({ behaviour: "smooth" });
                            window.scrollBy(0, 0);
                        }}>Education</span>
                        <span className="nav-elements" onClick={() => {
                            refs.refContact.current.scrollIntoView({ behaviour: "smooth" });
                            window.scrollBy(0, -20);
                        }}>Contact Me</span>
                    </div>
                </div>
                <CustomLinearProgress className="progressMainStyle" value={scrollTop} variant="determinate"  />
            </div>

        </>
    )
}
export default Navbar;

